var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatepicker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#EAEDF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.001 14.6654H10.001M18.6676 9.33203V11.9987M13.3343 9.33203V11.9987M13.201 22.6654H18.801C19.9211 22.6654 20.4811 22.6654 20.909 22.4474C21.2853 22.2556 21.5912 21.9497 21.783 21.5734C22.001 21.1455 22.001 20.5855 22.001 19.4654V13.8654C22.001 12.7453 22.001 12.1852 21.783 11.7574C21.5912 11.3811 21.2853 11.0751 20.909 10.8834C20.4811 10.6654 19.9211 10.6654 18.801 10.6654H13.201C12.0809 10.6654 11.5208 10.6654 11.093 10.8834C10.7167 11.0751 10.4107 11.3811 10.219 11.7574C10.001 12.1852 10.001 12.7453 10.001 13.8654V19.4654C10.001 20.5855 10.001 21.1455 10.219 21.5734C10.4107 21.9497 10.7167 22.2556 11.093 22.4474C11.5208 22.6654 12.0809 22.6654 13.201 22.6654Z",
    stroke: "#555FDD",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatepicker);
export default __webpack_public_path__ + "static/media/datepicker.fbfb49a2678bb76f770006ec433d5567.svg";
export { ForwardRef as ReactComponent };